const styles = {
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  input: {
    marginBottom: 16,
  },
  text: {
    marginBottom: 8,
    fontWeight: "bold",
  },
  cascader: {
    marginRight: 16,
    marginBottom: 16,
  },
  button: {
    marginRight: 16,
  },
  whiteBackground: {
    background: "white",
    marginBottom: 32,
  },
};

export default styles;
